<template>
  <div class="order-status-text">
    <span :class="{'unlink':status==5}" style="color: #409EFF;" v-if="status == 0">準備中 Pending</span>
    <span :class="{'unlink':status==5}" style="color:#c810d4;" v-if="status == 1">已審核 Approved</span>
    <span :class="{'unlink':status==5}" style="color:#d8d108;" v-if="status == 2">處理中 Processing</span>
    <span :class="{'unlink':status==5}" style="color: #179A16;" v-if="status == 3">已完成 Successful</span>
    <span :class="{'unlink':status==5}" style="color: #e95801;" v-if="status == 4">失敗 Fail</span>
    <span :class="{'unlink':status==5}" style="color: #cf1d06;" v-if="status == 5">已刪除 Deleted</span>
  </div>
</template>

<script>
export default {
  name: 'orderStatusText',
  props: ['status'],
}
</script>

<style>
</style>